<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="3">
        <v-card class="fill-height d-flex flex-column" outlined>
          <v-card-title>
            {{ title }}
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
              <v-autocomplete label="Ano da Legislação"
                v-model="params.ano"
                :items="options.ano"
                clearable dense
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="reset()">Limpar</v-btn>
            <v-btn @click="addLayer()" color="#244EA2" dark>
              Pesquisar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" lg="9">
        <div :id="mapid" style="height: calc(100vh - 200px); width: 100%;"></div>
      </v-col>
      <v-col cols="12">
        <v-container fluid>
          <h2
            class="text-h6 my-4"
          >
            Legislação (LOA)
          </h2>

          <v-row>
            <v-col
              v-for="l in legislacao"
              :key="l.codigo"
              cols="12"
              sm="12"
              md="6"
              lg="4"
            >
              <v-card outlined>
                <v-simple-table>
                  <tbody>
                    <tr>
                      <td style="width: 10%">
                        <b>Município</b>
                      </td>
                      <td>{{ l.municipio }}</td>
                    </tr>
                    <tr>
                      <td style="width: 10%">
                        <b>Órgão</b>
                      </td>
                      <td>{{ l.orgao }}</td>
                    </tr>
                    <tr>
                      <td style="width: 10%">
                        <b>Ano</b>
                      </td>
                      <td>{{ l.ano }}</td>
                    </tr>
                    <tr>
                      <td style="width: 10%">
                        <b>Número</b>
                      </td>
                      <td>{{ l.numero }}</td>
                    </tr>
                    <tr>
                      <td style="width: 10%">
                        <b>Valor</b>
                      </td>
                      <td>{{ l.valor }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import { uniqueId } from 'lodash'

import { getBounds, toViewParams } from '@/domain/library'

import api from '@/api/vue-exemplo'

export default {
  name: 'Legislacao',
  data: () => ({
    mapid: null,
    title: 'Legislação (LOA)',
    legislacao: [],
    params: {
      ano: null
    },
    options: {
      ano: []
    }
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onResize()
    })
  },
  mounted () {
    this.mapid = uniqueId()
    this.$nextTick(() => {
      this.map = L.map(this.mapid)
      this.map.fitBounds(getBounds())
      esri.basemapLayer('Topographic').addTo(this.map)

      L.Control.geocoder({
        position: "topleft",
        placeholder: "Pesquisar..."
      }).addTo(this.map)

      L.control.defaultExtent({
        title: 'Visão Inicial'
      }).addTo(this.map)

      this.addLayer()
    })

    api.getAnoLegislacao()
      .then(response => {
        this.options.ano = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    reset () {
      this.$refs.form.reset()
      this.removeLayer()
    },
    addLayer () {
      this.removeLayer()

      var style = () => { /* feature */
        return {
          fillColor: 'orange',
          weight: 2,
          opacity: 1,
          color: 'white',
          dashArray: '3',
          fillOpacity: 0.7
        }
      }

      var highlightFeature = (e) => {
        var layer = e.target
        layer.setStyle({
          weight: 5,
          color: '#666',
          dashArray: '',
          fillOpacity: 0.7
        })
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront()
        }
      }

      var resetHighlight = (e) => {
        this.geojson.resetStyle(e.target)
      }

      var click = (e) => {
        var codibge = e.target.feature.properties.codibge
        this.getLegislacao(codibge)
      }

      function onEachFeature (feature, layer) {
        layer.on({
          mouseover: highlightFeature,
          mouseout: resetHighlight,
          click: click
        })
      }

      this.$store.commit('setLoading', true)

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: 'seec:sqlvw_legislacao_pol_p29192',
        srsName: 'EPSG:4674',
        viewParams: toViewParams({
          pAno: this.params.ano
        })
      }

      axios.get(process.env.VUE_APP_GEOSERVER, {
        params: params
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            style: style,
            onEachFeature: onEachFeature
          }).addTo(this.map)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
        })
    },
    removeLayer () {
      if (this.geojson) {
        this.map.removeLayer(this.geojson)
        this.geojson = null
      }
    },
    getLegislacao(codibge) {
      api.getLegislacao({
        codibge: codibge
      })
        .then(response => {
          this.legislacao = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    }
  }
}
</script>